import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import { adminMcpServersQueryKey } from "./useAdminMcpServers";

interface UpdateServerOrgsArgs {
  serverId: string;
  orgIds: string[];
}

export function useAdminUpdateMcpServerOrgs() {
  const { mcpRegistryService } = useDomainServices();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ serverId, orgIds }: UpdateServerOrgsArgs) =>
      mcpRegistryService.adminUpdateServerOrgs(serverId, orgIds),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: adminMcpServersQueryKey,
      });
    },
  });
}
